import React from "react";
import { Button, Input, InputLabel, FormControl } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import "./SearchComponent.css";

const FIELD_LABELS = {
  id: "ID",
  name: "Nom",
  clientName: "Nom du client",
  posIdClient: "ID client",
  posName: "Point de vente",
  url: "URL",
  controllerName: "Contrôleur",
  username: "Nom d'utilisateur",
  firstname: "Prénom",
  lastname: "Nom",
  commandAction: "Action",
  creationDate: "Date de création",
};

const humanizeAttr = (attr) => {
  const withSpaces = attr.replace(/([a-z])([A-Z])/g, "$1 $2");
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};

const fieldLabel = (attr) => FIELD_LABELS[attr] || humanizeAttr(attr);

const SearchComponent = (props) => {


  const dispatch = useDispatch();
  const searchModel = useSelector((state) => state.performSearchActionReducer);


  const handleOnChange = (event) => {
    dispatch({
      type: "UPDATE_SEARCH_MODEL_BY_EVENT",
      payload: { key: event.target.name, value: event.target.value },
    });
  };

  const clearData = () => {
    dispatch({
      type: "CLEAN_SEARCH_MODEL",
    });
  };

  const hideSearchPanel = () => {
    document.getElementsByClassName("search-panel")[0].classList.toggle("hide");
  };

  const performSearchAction = (model) => {
    if (model === undefined) {
      model = searchModel;
    }
    props.searchAction(model);
    document.getElementsByClassName("search-panel")[0].classList.toggle("hide");
  };

  /**
   *  default content of component
   */
  let defaulContent;
  if (searchModel === null || searchModel === undefined) {
    defaulContent = <div></div>;
  } else {
    defaulContent = Object.keys(searchModel).map((attr, index) => {
      const label = props.labelsModel === undefined ? fieldLabel(attr) : props.labelsModel[attr];
      return (
        <FormControl key={index} className="search-field">
          <InputLabel>{label}</InputLabel>
          <Input
            name={attr}
            placeholder={label}
            value={searchModel[attr]}
            onChange={handleOnChange}
          />
        </FormControl>
      );
    });
  }

  return (
    <div>
      <div className="search-panel-header">
        <h3>Filtres de recherche</h3>
        <div onClick={hideSearchPanel} className="close-icons">
          <i className="fa fa-times" />
        </div>
      </div>

      <div className="search-panel-content">
        <div className={
          "search-panel-fields" +
          (searchModel !== null && searchModel !== undefined && Object.keys(searchModel).length > 3
            ? " search-panel-fields-grid"
            : "")
        }>
          {props.children !== undefined ? props.children : defaulContent}
        </div>

        <div className="action-panel">
          <Button
            variant="contained"
            color="primary"
            onClick={() => performSearchAction()}
          >
            <i className="fa fa-search" style={{ paddingRight: "6px" }} />
            Rechercher
          </Button>
          <Button variant="outlined" onClick={clearData}>
            Réinitialiser
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
